import React, {useEffect} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import { doQuotesQuery } from "../utils/queries"
import { getRuntimeReferrer } from "../utils/runtimeOverrides"
import LoadingSpinner from "./LoadingSpinner"

// const isProd: boolean =
//         (document.referrer.indexOf("vakuutustenvertailu") > -1) ||
//         (document.referrer.indexOf("effortia") > -1) ||
//         (document.referrer.indexOf("wl.vakuutuslaskuri") > -1)
const isProd: boolean =
				(document.baseURI.indexOf("wl.vakuutuslaskuri") > -1);
const referrer = getRuntimeReferrer()

const Signing = () => {
  const navigate = useNavigate()
  const {state} = useLocation();

  const handleCompletedDataQuery = async (data: any) => {
    const completedDataQuery = await doQuotesQuery(data, isProd, referrer)
  }

  useEffect(() => {
    handleCompletedDataQuery(state)
  }, [])

  return (
    <div className="flex flex-col items-stretch justify-center flex-1">
      <div className="w-full p-4 border-b">
        <div className="m-auto vakuutuslaskuri-logo"></div>
      </div>
      <div
        className="flex flex-col flex-1 items-stretch justify-center max-w-xl mt-4 sm:mt-0 m-auto px-2 sm:px-6 lg:px-8 sm:p-10 bg-white">
        <h1 className="text-xl font-medium tracking-tight text-gray-900 text-center">Please wait while redirecting to
          Signicat...</h1>
        <LoadingSpinner isVisible={true}/>
        <div className="flex flex-row justify-center space-x-4 mt-10">
          <button
            onClick={() => navigate("/result/success")}
            className="my-2 bg-gray-300 hover:bg-gray-400 duration-200 text-black hover:text-white border py-3 px-8 font-normal text-sm rounded-3xl transition-all">
            Simulate success
          </button>
          <button
            onClick={() => navigate("/result/error")}
            className="my-2 bg-gray-300 hover:bg-gray-400 duration-200 text-black hover:text-white border py-3 px-8 font-normal text-sm rounded-3xl transition-all">
            Simulate error
          </button>
        </div>
      </div>
      <div className="px-2 sm:px-6 lg:px-8 py-2 border-t">
        <div className="py-6 text-center text-sm font-normal text-gray-500">
          Vakuutuslaskuri.fi is a service provided by Little Buck Oy
        </div>
      </div>
    </div>
  )
}

export default Signing
